import DatePicker from 'vue2-datepicker';
import utils from './utils.js';
import { Validator } from 'simple-vue-validator';

export default {
    components: {
        DatePicker
    },
    props: ['staff_members', 'selected_staff', 'login_user_id','salon_selected','add_break_start_time','add_break_end_time'],
    name: 'break_popover',
    data(){
        return {
            break_date :'',
            break_start_time : '',
            break_end_time :'',
            staff_selected: 0,
            break_notes: '',
            start_time_greater_than_end_time: false,
        }
    },
    mounted(){
        if(this.$session.has('selected_break_date'))this.break_date = utils.date_from_sql_to_bookjoy_format(this.$session.get('selected_break_date'));
        else this.break_date = utils.date_from_sql_to_bookjoy_format(this.$store.state.selected_date);
        this.break_start_time = this.add_break_start_time;
        this.break_end_time   = this.add_break_end_time;
        this.staff_selected   = this.selected_staff;
        this.start_time_greater_than_end_time = false;
    },
    destroyed(){
        if(this.$session.has('selected_break_date')) this.$session.remove('selected_break_date')
    },
    methods:{
        add_break() {
            let _this = this;
            this.$validate().then(function (success) {
                if (success) {
                    var start_time = utils.time_from_bookjoy_format_to_sql(_this.break_start_time)
                    var end_time = utils.time_from_bookjoy_format_to_sql(_this.break_end_time)
                    if(!utils.comparing_startime_and_endtime(start_time, end_time))
                    {
                        _this.start_time_greater_than_end_time = true;
                        return;
                    }
                    _this.start_time_greater_than_end_time = false;
                    var duration = utils.time_duration_in_min(start_time, end_time);
                    document.getElementsByClassName('add_break_button')[0].innerHTML="Please Wait";
                    document.getElementsByClassName('add_break_button')[0].disabled=true;
                    _this.$store.dispatch('add_new_break',[_this.$store.state.api,
                        _this.salon_selected.store_id,
                        _this.staff_selected,
                        utils.date_from_bookjoy_format_to_sql(_this.break_date),
                        utils.date_from_bookjoy_format_to_sql(_this.break_date),
                        start_time,
                        end_time,
                        duration,
                        _this.break_notes,
                        _this.login_user_id,
                        _this.Constants.BOOKED_THROUGH_ADMIN,
                        _this.Constants.BOOKING_TYPE_ADD_STAFF_BREAK
                    ]).then(()=>{
                        _this.$emit('update_events', 'staff_break_popup');
                    })
                }
            });            
        },
        time_validation(){
            var start_time = utils.time_from_bookjoy_format_to_sql(this.break_start_time)
            var end_time = utils.time_from_bookjoy_format_to_sql(this.break_end_time)
            if(!utils.comparing_startime_and_endtime(start_time, end_time)){
                this.start_time_greater_than_end_time = true;
            }else{
                this.start_time_greater_than_end_time = false;
            }
        }
    },
    validators: {
        break_start_time: function (value) {
          return Validator.value(value).required();
        },
        break_end_time: function (value) {
            return Validator.value(value).required();
        },
        staff_selected: function (value) {
            return Validator.value(value).required();
        },
        break_date: function (value) {
            return Validator.value(value).required();
        },
    }
}